
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/new",
      function () {
        return require("private-next-pages/events/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/new"])
      });
    }
  